var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('the-mask',{directives:[{name:"focus",rawName:"v-focus"}],staticClass:"otp-input",attrs:{"type":"text","value":_vm.value,"mask":"###-###","placeholder":"***-***","masked":false},on:{"input":_vm.onInput}})}
var staticRenderFns = []

export { render, staticRenderFns }